import { ref, watch, computed, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'
import contractStoreModule from '@/views/modules/contract/store/contractStoreModule'
import { useUtils } from '@core/libs/i18n'
                
                
               

export default function useContractsList(root) {
  const { t } = useUtils()

  const C_STORE = 'contracts'

  // Register module
  if (!store.hasModule(C_STORE))
    store.registerModule(C_STORE, contractStoreModule)

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(C_STORE))
      store.unregisterModule(C_STORE)
  })


  const refContractListTable = ref(null)
  const { toaster } = useGroupEdit(root)


  const tableColumns = [
    { key: 'name', sortable: false, label: t('Name')},
    { key: 'contractor_name', sortable: false, label: t('Contractor')},
    { key: 'color', sortable: false, label: t('Color')},
    { key: 'actions',label:t('actions') },
  ]

  const perPage = ref(10)
  const totalContracts = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {

    const localItemsCount = refContractListTable.value ? refContractListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalContracts.value,
    }
  })

  const refetchData = () => refContractListTable.value.refresh()

  const filter = ref({})

  watch([currentPage, perPage, searchQuery ], () => {
    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()
  })


  const fetchContracts = (ctx, callback) => {

    requestStatus.value = true
    store
      .dispatch('contracts/fetchContracts', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.contracts
        const { total } = response.data.contracts.meta

        callback(data)
        totalContracts.value = total
      })
      .catch(e => {
        requestStatus.value = false
        console.log(e)
      })
  }


  // const removeGroup = (id) => {
  //
  //   root.$swal({
  //     title: root.$i18n.t("Are You Sure"),
  //     text: root.$i18n.t("Do you want to delete this group?"),
  //     showCancelButton: true,
  //     confirmButtonText: root.$i18n.t('Delete'),
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-outline-danger ml-1',
  //     },
  //     buttonsStyling: false,
  //   }).then(result => {
  //     if (result.value) {
  //       requestStatus.value = true
  //       store.dispatch('app-group/deleteGroup', id)
  //         .then(_ => {
  //           toaster('Group Deleted Successfully')
  //           refetchData()
  //         })
  //         .catch(reason => console.log(reason))
  //     }
  //   })
  // }




  return {

    fetchContracts,
    tableColumns,

    perPage,
    currentPage,
    totalContracts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refContractListTable,
    // removeGroup,
    requestStatus,
    refetchData,

  }
}
